import React from 'react'

const NewRelease = () => {
    return (
        <div>NewRelease</div>
    )
}

export default NewRelease